import { managerListSidePanelStore } from 'utils/MobxDataManager/singletons';
import { DecisionStore } from 'nomst/Stores/Decision/decision.store';
import { WorkflowStatusListType } from 'typings/enums';
import { navigateToNoMst } from 'utils/MobxDataManager/singletons';

let decisionStore: DecisionStore;

const init = (decision: DecisionStore) => {
    decisionStore = decision;
};

const resetManagerView = async (): Promise<void> => {
    await managerListSidePanelStore.resetManagerList();
    // if this is a first level manager we need to find out which status the team is in
    // and then we need to redirect them to that status and repull
    if (managerListSidePanelStore.isFirstLevelManager) {
        const listType = getFirstLevelManagerWorkflowStatus();

        managerListSidePanelStore.setWorkflowStatusType(listType);
        return navigateToNoMst.navigateToTeamsView(decisionStore.cycleId, [managerListSidePanelStore.userEmployeeId]);
    }

    // this is not a first level manager so be sure to jump out of single team only view
    // and finish pulling down managers and budgets
    const managerSourceIds = managerListSidePanelStore.selectedManagerIds;
    managerListSidePanelStore.setToggleSidePanel(true);

    if (!managerSourceIds) {
        decisionStore.teamDecisionStore.setTeamSelection(false);
        return;
    }

    // if they didn't send every manager forward or back just refresh the current status
    if (managerListSidePanelStore.allManagerIds.length) {
        return navigateToNoMst.navigateToManagerView(
            decisionStore.cycleId, managerListSidePanelStore.workflowStatusType);
    }
    // if they did select all and perform an action select all should no longer be toggled and find them
    // the next appropriate status to look at
    managerListSidePanelStore.toggleSelectAllManagers(false);
    return navigateToNoMst.navigateToManagerView(decisionStore.cycleId, getFirstManagerWorkflowStatus());
};

const getFirstLevelManagerWorkflowStatus = (): WorkflowStatusListType => {
    let listType;
    managerListSidePanelStore.managerWorkflowSummaryLookups.forEach(summary => {
        if (summary.count) {
            listType = summary.listType;
        }
    });
    return !listType ? WorkflowStatusListType.Open : listType as WorkflowStatusListType;
};

const getFirstManagerWorkflowStatus = (): WorkflowStatusListType => {
    let i: number;
    const summaries = managerListSidePanelStore.managerWorkflowSummaryLookups;
    for (i = 0; i < summaries.length; i++) {
        if (summaries[i].count) {
            return summaries[i].listType as WorkflowStatusListType;
        }
    }

    return WorkflowStatusListType.Open;
};

const doesWorkflowStatusExist = (status: WorkflowStatusListType): boolean => {
    const summaries = managerListSidePanelStore.managerWorkflowSummaryLookups;
    return summaries?.some(summary => summary.count && summary.listType === status as string);
};

export {
    init,
    resetManagerView,
    getFirstLevelManagerWorkflowStatus,
    getFirstManagerWorkflowStatus,
    doesWorkflowStatusExist
};